import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/default/environment';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { PurpleSimpleButtonComponent, PurpleSimpleNotificationService } from '@purple-lib/purple-ui-widgets';
import { PurpleBreakpointsService, PurpleLoaderService, PurpleLoggerService, PurplePinComponent } from '@purple-lib/purple-utilities';

@Component({
  selector: 'purple-fit-select-broker ',
  templateUrl: './purple-fit-select-broker.component.html',
  styleUrls: ['./purple-fit-select-broker.component.scss'],
  imports: [CommonModule, FormsModule, NzDrawerModule, NzModalModule, PurpleSimpleButtonComponent, PurplePinComponent]
})
export class PurpleFitSelectBrokerComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private psNotSvc: PurpleSimpleNotificationService,
    private location: Location,
    public breakSvc: PurpleBreakpointsService,
    private loaderSvc: PurpleLoaderService,
    private logger: PurpleLoggerService) { }

  pinValue: string | undefined;
  pinCodes: Map<number, string | undefined> = new Map<number, string | undefined>();
  lan: string = environment.DEFAULT_LANGUAGE;
  translations: Map<string, Map<string, string>> | undefined | null;
  isLoading: boolean = false;

  ngOnInit() {
    this.loaderSvc.addRequest("broker");
    this.route.params.subscribe(async (params: Params) => {
      this.loaderSvc.addRequest("broker");
      const lan = params["cultureId"];
      this.lan = lan ?? environment.DEFAULT_LANGUAGE;

      this.logger.debug("Language: ", this.lan);

      await this.getBrokerData();
      this.loaderSvc.removeRequest("broker", 600);
    });

    this.route.queryParams.subscribe((params: Params) => {
      const code = params["code"];

      if (this.isValidCode(code ?? undefined)) {
        this.pinValue = code;
      }
    });

    this.loaderSvc.removeRequest("broker", 600);
  }

  private async getBrokerData() {
    try {
      const response = await fetch('https://purple-fit-broker.pages.dev/broker.json');

      if (!response.ok) {
        this.psNotSvc.showPurpleSimpleNotification({
          title: 'Qualcosa è andato storto',
          message: 'Impossibile avviare il broker',
          buttonText: 'Ok',
          autoClose: true
        })
        return;
      }

      const data: IBrokerData = await response.json();

      this.translations = new Map(
        Object.entries(data.localizations || {}).map(([languageId, translations]) => {
          const translationsMap = new Map(
            Object.entries(translations as Record<string, string>)
          );
          return [languageId, translationsMap];
        })
      );

      this.logger.debug("Translations:", this.translations);
    } catch (error) {
      this.psNotSvc.showPurpleSimpleNotification({
        title: 'Qualcosa è andato storto',
        message: 'Impossibile avviare il broker',
        buttonText: 'Ok',
        autoClose: true
      });
      return;
    }
  }

  async setEndpoint() {
    this.isLoading = true;
    const check = this.pinCodes.size != 6 || Array.from(this.pinCodes.values()).includes(undefined);

    this.logger.debug("Check: ", this.pinCodes, " - ", check);

    if (check) {
      this.psNotSvc.showPurpleSimpleNotification({
        title: this.translations?.get(this.lan)?.get('broker_page_incomplete_code_error_title') ?? 'Incomplete code',
        message: this.translations?.get(this.lan)?.get('broker_page_incomplete_code_error_message') ?? 'Please enter all the numbers in the code to continue.',
        buttonText: 'Ok',
        autoClose: true,
        mobileSettings: {
          mobileType: 'drawer',
        }
      });
      this.isLoading = false;
      return;
    }

    try {
      //const code = "" + this.pinCodes.get(1) + this.pinCodes.get(2) + this.pinCodes.get(3) + this.pinCodes.get(4) + this.pinCodes.get(5) + this.pinCodes.get(6);

      let code = "";

      Array.from(this.pinCodes.keys())
        .sort((a, b) => a - b)
        .forEach((key) => {
          const value = this.pinCodes.get(key);
          this.logger.debug(`Key: ${key}, Value: ${value}`);
          code += value;
        });

      const response = await fetch(`https://purple-fit-broker.pages.dev/broker-${code}.json`);

      if (!response.ok) {
        this.psNotSvc.showPurpleSimpleNotification({
          title: this.translations?.get(this.lan)?.get('broker_page_company_not_found_error_title') ?? 'Something went wrong',
          message: this.translations?.get(this.lan)?.get('broker_page_company_not_found_error_message') ?? 'Error connecting to server. Please try again later.',
          buttonText: 'Ok',
          autoClose: true
        })
        this.isLoading = false;
        return;
      }

      const data: IBrokerCustomerData = await response.json();

      console.log("Endpoint: ", data.endpoint);
      localStorage.setItem("ApiBasePath", data.endpoint);
      localStorage.setItem("CompanyName", data.companyName ?? '');
      const isApiAvailable = await this.checkApiAvailability();

      if (!isApiAvailable) {
        // Rimuovi il loader prima di cambiare pagina per pulizia
        this.loaderSvc.removeRequest(environment.LOADER_ID);
        this.isLoading = false;
        this.psNotSvc.showPurpleSimpleNotification({
          title: this.translations?.get(this.lan)?.get('broker_page_company_no_access_error_title') ?? 'Applicazione non raggiungibile',
          message: this.translations?.get(this.lan)?.get('broker_page_company_no_access_error_message') ?? 'Errore di connessione al server. Riprova più tardi.',
          buttonText: 'Ok',
          autoClose: true
        })
        return;
      }
      this.location.historyGo(1);
      const url = `${this.lan}/login`;
      this.location.go(url);
      window.location.reload();

      this.isLoading = false;
    } catch (error) {
      this.psNotSvc.showPurpleSimpleNotification({
        title: this.translations?.get(this.lan)?.get('broker_page_company_not_found_error_title') ?? 'Something went wrong',
        message: this.translations?.get(this.lan)?.get('broker_page_company_not_found_error_message') ?? 'Error connecting to server. Please try again later.',
        buttonText: 'Ok',
        autoClose: true
      })


      this.isLoading = false;
    }
  }
  private async checkApiAvailability(): Promise<boolean> {
    try {

      const apiBasePath = localStorage.getItem("ApiBasePath");

      if (!apiBasePath) {
        console.error('API base path is not set in localStorage.');
        return false;
      }

      const response = await fetch(apiBasePath);
      return response != null;
    } catch (error) {
      return false;
    }
  }

  pinCodeChange(pinCodes: Map<number, string | undefined>) {
    this.logger.debug("PinCodeChange: ", pinCodes);
    this.pinCodes = pinCodes;
  }

  isValidCode(code: string | undefined) {
    if (code == undefined) {
      return false;
    }

    const re = new RegExp('^[0-9]{6}$');
    return re.test(code);
  }

  buttonDisabled(): boolean {
    return this.pinCodes.size < 6 || Array.from(this.pinCodes.values()).some(value => value === undefined);
  }

}

interface IBrokerLocalization {
  [key: string]: string;
}

interface IBrokerData {
  localizations: {
    [languageCode: string]: IBrokerLocalization;
  };
}

interface IBrokerCustomerData {
  endpoint: string;
  companyName: string| undefined;
}